import {Localizations} from '~/lib/type';

export const countries: Localizations = {
  default: {
    label: 'Hong Kong (HKD $)',
    language: 'ZH_TW',
    country: 'HK',
    currency: 'HKD',
  },
  '/en': {
    label: 'Hong Kong (HKD $)',
    language: 'EN',
    country: 'HK',
    currency: 'HKD',
  },
  // Simplified Chinese: served on /zh-cn. It intentionally keeps language
  // ZH_TW so every Shopify/Sanity/translation lookup behaves exactly like the
  // Traditional site (no new code paths, no missing-locale errors); the page
  // is converted Traditional→Simplified client-side, keyed off the /zh-cn
  // path prefix (see SimplifiedChinese).
  '/zh-cn': {
    label: 'Hong Kong (HKD $)',
    language: 'ZH_TW',
    country: 'HK',
    currency: 'HKD',
  },
};

export const hkLocales: Localizations = {
  default: {
    label: 'Hong Kong (HKD $)',
    language: 'ZH_TW',
    country: 'HK',
    currency: 'HKD',
  },
  '/en': {
    label: 'Hong Kong (HKD $)',
    language: 'EN',
    country: 'HK',
    currency: 'HKD',
  },
};

export const twLocales: Localizations = {
  default: {
    label: 'Taiwan (TWD $)',
    language: 'ZH_TW',
    country: 'TW',
    currency: 'TWD',
  },
  '/en': {
    label: 'Taiwan (TWD $)',
    language: 'EN',
    country: 'TW',
    currency: 'TWD',
  },
};
